import React from "react";
import { Paper, Stack, Typography, Button, Box } from "@mui/material";
import { Iconify } from "../../../Minimal/src/components/iconify/iconify";

const PromotionSummaryCard = ({
  promotionCount = 0,
  totalApplicable = 0,
  onViewClick,
  disabled = false,
  hideWhenNotApplied = false,
  showTrailingDivider = false,
}) => {
  if (hideWhenNotApplied && promotionCount <= 0) {
    return null;
  }

  const message =
    promotionCount > 0
      ? `${promotionCount} promotion${promotionCount !== 1 ? "s" : ""} applied!`
      : totalApplicable > 0
        ? `${totalApplicable} promotion${totalApplicable !== 1 ? "s" : ""} available to apply!`
        : "0 promotions available";

  return (
    <Paper
      variant="elevation"
      elevation={0}
      sx={{
        px: 1,
        py: 0,
        height: "36px",
        display: "flex",
        alignItems: "center",
        backgroundColor: "#E3F2FD",
        borderRadius: "10px",
        border: "none",
        flex: "1 1 auto",
        minWidth: 0,
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={1}
        sx={{ width: "100%", minWidth: 0 }}
      >
        <Stack direction="row" spacing={0.75} alignItems="center" sx={{ flex: 1, minWidth: 0 }}>
          <Iconify
            icon="ri:discount-percent-line"
            width={20}
            height={20}
            sx={{ color: "#F8991D", flexShrink: 0 }}
          />
          <Typography
            fontWeight={500}
            noWrap
            sx={{ color: "#000", fontSize: "0.8rem", lineHeight: 1.2, minWidth: 0 }}
          >
            {message}
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={0.75} sx={{ flexShrink: 0 }}>
          <Button
            variant="contained"
            size="small"
            onClick={onViewClick}
            disabled={disabled}
            sx={{
              minWidth: "52px",
              height: "28px",
              backgroundColor: "#F8991D",
              color: "#fff",
              borderRadius: "6px",
              textTransform: "none",
              fontWeight: 600,
              px: 1.25,
              py: 0,
              fontSize: "0.75rem",
              flexShrink: 0,
              "&:hover": { backgroundColor: "#F8991D" },
              "&.Mui-disabled": { backgroundColor: "#ccc", color: "#666" },
            }}
          >
            View
          </Button>
          {showTrailingDivider ? (
            <Box
              sx={{
                width: "1px",
                height: 28,
                bgcolor: "#bdbdbd",
                flexShrink: 0,
              }}
            />
          ) : null}
        </Stack>
      </Stack>
    </Paper>
  );
};

export default PromotionSummaryCard;
